import { useState } from "react";
import { useTranslation } from "react-i18next";

import VideoButton from "./button";
import RecordVideo from "./recordVideo";
import VideoPreview from "./videoPreview";

export default function ({
  agreeAccessCamera,
  capturing,
  durationOfVideo,
  fields,
  loading,
  permissionCamera,
  tryAgain,
  video,
  webcamRef,
  onGetPermissionCamera,
  onNextStep,
  onTryAgain,
  onStopCaptureClick,
  onStartCaptureClick,
}) {
  const { t } = useTranslation();
  const [rules, setRules] = useState(false);
  const { value: textCapture } =
    fields.find((el) => el.key === "video_text") ?? {};

  const onChangeRules = (e) => setRules(!rules);

  return (
    <>
      {tryAgain ? (
        <VideoPreview
          durationOfVideo={durationOfVideo}
          video={video}
          onTryAgain={onTryAgain}
        />
      ) : (
        <RecordVideo
          agreeAccessCamera={agreeAccessCamera}
          capturing={capturing}
          textCapture={textCapture}
          permissionCamera={permissionCamera}
          webcamRef={webcamRef}
          onGetPermissionCamera={onGetPermissionCamera}
          onStopCaptureClick={onStopCaptureClick}
          onStartCaptureClick={onStartCaptureClick}
        />
      )}

      <VideoButton
        classNameBtn={!rules ? "disabled-button-large cursor-not-allowed" : ""}
        name={t("card-page.button-send")}
        disabled={!rules}
        loading={loading}
        tryAgain={tryAgain}
        rules={rules}
        onNextStep={onNextStep}
        onChangeRules={onChangeRules}
      />
    </>
  );
}
